// extracted by mini-css-extract-plugin
export var deliveryRow = "_jx-a";
export var fixedHeight = "_jx-4";
export var freightLogo = "_jx-9";
export var fullWidth = "_jx-3";
export var priceColumn = "_jx-5";
export var radioSelected = "_jx-7";
export var radioUnselected = "_jx-6";
export var selectedOption = "_jx-2";
export var selectedOptionContainer = "_jx-1";
export var selection = "_jx-0";
export var tallSkeletonText = "_jx-8";